import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { StakeholderRole } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useChangeRole = () => {
  const { mutate: changeRole } = useAppMutation([QueryKey.PATCH_STAKEHOLDER_ROLE], {
    mutationFn: ({ role, stakeholderId }: { role: StakeholderRole; stakeholderId: string }) =>
      ApiService.patch({
        endpoint: BackendRoute.STAKEHOLDERS,
        routePath: [stakeholderId, 'change-role', role],
      }),
  });
  return { changeRole };
};
